import { Anchor, Text, Group, Flex, Stack } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import {
  FooterFacebookIcon,
  FooterInstagramIcon,
  FooterLinkedInIcon,
  FooterLogo,
} from "../../shared/svg";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const Footer = () => {
  const matches = useMediaQuery("(max-width: 970px)");
  const logoMatches = useMediaQuery("(max-width: 1125px)");
  const { t } = useTranslation();

  return (
    <Stack bg="#000" c="#fff" p="lg" align={matches ? "center" : "start"}>
      <Flex
        justify="space-between"
        gap={40}
        wrap="wrap"
        align={matches ? "center" : "start"}
        direction={matches ? "column" : undefined}
      >
        <FooterLogo mobile={logoMatches} />
        <Flex
          align="center"
          gap={matches ? "24px" : "40px"}
          direction={matches ? "column" : undefined}
        >
          <Anchor c="#fff" to="/" component={Link}>
            {t("home")}
          </Anchor>
          <Anchor c="#fff" to="/for-coaches" component={Link}>
            {t("for_coaches")}
          </Anchor>
          <Anchor c="#fff" to="/terms-of-service" component={Link}>
            {t("terms_of_service")}
          </Anchor>
          <Anchor c="#fff" to="/privacy-policy" component={Link}>
            {t("privacy_policy")}
          </Anchor>
        </Flex>
        <Stack gap={matches ? "24px" : "12px"}>
          <Text>{t("connect_with_us")}</Text>
          <Group>
            <FooterFacebookIcon />
            <FooterInstagramIcon />
            <FooterLinkedInIcon />
          </Group>
        </Stack>
      </Flex>
      <Stack mt={matches ? 16 : 0} align={matches ? "center" : "start"} gap={0}>
        <Text size={matches ? "10px" : "16px"}>© 2021 CompetenzLab.</Text>
        <Text size={matches ? "10px" : "16px"}>{t("all_rights_reserved")}</Text>
        <Text size={matches ? "10px" : "16px"}>{t("address")}</Text>
      </Stack>
    </Stack>
  );
};
